import {eTipoPermissao} from '@/enums/ePermissoes';
export default [
 {
  description: 'Almoxarifado',
  path: '/merenda/meralmoxarifado',
  name: 'meralmoxarifado',
  component: () => import('@/views/merenda/meralmoxarifado/Index.vue'),
  meta: {
   permissions: [eTipoPermissao.CENTRODEDISTRIBUICAONOVO_MENU_1000300299],
  },
  goesToMenu: true,
 },
 {
  description: 'Cadastro de Almoxarifado',
  path: '/merenda/meralmoxarifado/cadastro/:id?',
  parent: 'meralmoxarifado',
  name: 'meralmoxarifado_create',
  component: () => import('@/views/merenda/meralmoxarifado/InclusaoEdicao.vue'),
  meta: {
   permissions: [eTipoPermissao.CENTRODEDISTRIBUICAONOVO_MENU_1000300299],
  },
  goesToMenu: true,
 },
]
